import { Flex, Span } from '@fareye/ui'
import React, { useRef } from 'react'
import { Details, Icon, IconLine, Line, Stage } from '../../../style/styled'
import FieldValue from './FieldValue'
import PoiDetails from './PoiDetails'

export default (props: any) => {
  const { name, style, eta, icon, line, tripRunningStatus } = props

  const [poiDetails, setPoiDetails] = React.useState(null)
  const iconSize = 20

  const stageRef = useRef(null)

  return (
    <Stage column style={style && style.stage} ref={stageRef}>
      <Details column disableTransform={true}>
        {name ? (
          <Span
            style={{
              ...style?.name,
              ...{
                transform: 'translateX(calc(1ch - 50%))',
                width: 'max-content',
                maxWidth: '12em'
              }
            }}
            variant="ellipsis"
          >
            {name}
          </Span>
        ) : (
          <Span variant="ellipsis">&nbsp;</Span>
        )}
      </Details>
      {/* {stoppage && (
        <Stoppages close={() => setStoppage(null)} stoppages={stoppages} />
      )} */}
      <PoiDetails poiDetails={poiDetails} close={() => setPoiDetails(null)} />
      <IconLine style={style && style.iconLine}>
        <Icon
          onClick={() => setPoiDetails(props)}
          style={style && style.iconWrapper}
        >
          {icon}
        </Icon>
        {line && (
          <Line
            borderColor={line.color}
            width={line.width}
            borderStyle={line.style}
            style={{ top: `${iconSize / 2}px` }}
          />
        )}
        <Flex
          width={1}
          style={{ position: 'absolute', top: `${iconSize * 0.25}px` }}
          justifyContentSpaceAround
        >
          {/* {stoppages && stoppages.length > 0 && (
            <FaStopCircle
              onClick={() => setStoppage(stoppages)}
              title={`${stoppages.length} Stoppage`}
              style={{
                zIndex: 3,
                background: '#fff'
              }}
              color="#d6e92a"
              size={iconSize * 0.8}
            />
          )} */}
          {/* {overspeeding > 0 && typeof overspeeding === 'number' && (
            <FaExclamationTriangle
              title={`${overspeeding} Overspeeding${
                overspeeding > 1 ? 's' : ''
              }`}
              style={{
                zIndex: 3,
                background: '#fff'
              }}
              color="#e92a2a"
              size={iconSize * 0.8}
            />
          )} */}
        </Flex>
      </IconLine>
      <Details column disableTransform={true}>
        <FieldValue
          style={{ maxWidth: 120 }}
          valueStyle={{
            transform: 'translateX(-50%)'
          }}
          value={eta}
        />
        <FieldValue
          style={{
            maxWidth: 90,
            justifyContent: 'center',
            color: tripRunningStatus
              ? tripRunningStatus.status === '+'
                ? 'red'
                : 'green'
              : 'inherit'
          }}
          valueStyle={{
            position: 'absolute',
            bottom: 0,
            transform: 'translateX(-50%)'
          }}
          value={`${
            tripRunningStatus
              ? `${tripRunningStatus.status} ${tripRunningStatus.duration}`
              : ''
          }`}
        />
      </Details>
    </Stage>
  )
}
